import {TCD_VEHICLE_TYPE_CAR, TCD_VEHICLE_TYPE_TRUCK} from "components/TecRmi/TecRmiVehicleTypeSuppliers";

export default function tecRmiTypeDetailsParse(typeDetails) {
  let tcdVehicleType = TCD_VEHICLE_TYPE_CAR

  if(!typeDetails?.ShowAsCar && typeDetails?.ShowAsTruck){
    tcdVehicleType = TCD_VEHICLE_TYPE_TRUCK
  }

  return {
    tcdVehicleType,
    tcdMakeId: typeDetails?.TcdMakeId,
    tcdRangeId: typeDetails?.TcdRangeId,
    tcdTypeId: typeDetails?.TcdTypeId,
    typeId: typeDetails?.TypeId,
  }
}